<template>
    <div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label :for="searchId">Search</label>
                    <input
                        :id="searchId"
                        type="search"
                        class="form-control form-control-sm"
                        :placeholder="placeholder"
                        :value="search"
                        autocomplete="off"
                        @input="$emit('update:search', $event.target.value)"
                    >
                </div>
            </div>
        </div>
        <form v-if="showFilters" @submit.prevent="$emit('apply')">
            <div class="row">
                <slot/>
                <div class="col-md-4 mb-1">
                    <label>&nbsp;</label>
                    <br>
                    <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0">
                        Apply Filter
                    </button>
                    <button type="button" class="btn btn-warning glow mb-1 mb-sm-0" @click="$emit('reset')">
                        Reset Filter
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'ListControls',
    props: {
        search: {
            type: String,
            default: '',
        },
        searchId: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: 'Search this table',
        },
        showFilters: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
